<div [ngSwitch]="type">
  <div *ngSwitchCase="'card'" fxLayout="row">
    <div>
      <ngx-skeleton-loader
        appearance="circle"
        [theme]="{ width: '50px', height: '50px', 'margin-top': '15px', 'margin-right': '20px' }"
      >
      </ngx-skeleton-loader>
    </div>

    <div fxLayout="column">
      <ngx-skeleton-loader
        class="sk1"
        [theme]="{
          width: '100px',
          'border-radius': '0',
          height: '15px',
          'margin-top': '15px'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        class="sk2"
        [theme]="{
          width: '150px',
          'border-radius': '0',
          height: '15px',
          'margin-top': '5px'
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
  <div *ngSwitchCase="'dashboard'">
    <div>
      <ngx-skeleton-loader [theme]="{ width: '200px', height: '40px', 'margin-top': '10px', 'margin-right': '7.5%' }">
      </ngx-skeleton-loader>
    </div>
    <div>
      <ngx-skeleton-loader
        [theme]="{
          width: '85%',
          'border-radius': '0',
          height: '100%',
          margin: 'auto'
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
  <div *ngSwitchCase="'chart_report'">
    <div>
      <ngx-skeleton-loader [theme]="{ width: '200px', height: '40px', 'margin-top': '10px', 'margin-right': '7.5%' }">
      </ngx-skeleton-loader>
    </div>
    <div>
      <ngx-skeleton-loader
        [theme]="{
          width: '85%',
          'border-radius': '0',
          height: '200px',
          margin: 'auto'
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>

  <div *ngSwitchCase="'roles'">
    <div>
      <ngx-skeleton-loader [theme]="{ width: '700px', height: '200px' }"> </ngx-skeleton-loader>
    </div>
  </div>
  <div *ngSwitchDefault>output2</div>
</div>
